// External Imports
import { Fragment, useContext, useState } from "react";
import { TbChevronDown, TbChevronUp } from "react-icons/tb";

// Internal Imports
import { isoDateToString } from "../../util/format-date";
import Heading from "../UI/Heading";
import NoRecordsFound from "../UI/NoRecordsFound";
import { UtilityContext } from "../../context/util-context";
import { formatCurrency, toTitleCase } from "../../util/format-text";

/** ========================================================================
 * * PaymentDisputes Component
 * This component renders a list of disputes on a payment.
 * ========================================================================== */

export default function PaymentDisputes({ disputes = [] }) {
  const { navigate } = useContext(UtilityContext);
  // Initialize States
  const [show, setShow] = useState(false);

  // Sort disputes by date
  disputes = disputes.sort(
    (a, b) => new Date(b.dateCreated) - new Date(a.dateCreated)
  );

  return (
    <div className="grid gap-2">
      <Heading
        title="Disputes"
        text="List of all disputes on this payment."
        onClick={() => setShow(!show)}
        isBackArrow={false}
      >
        {disputes.length > 0 && (
          <div className="px-2 text-sm text-white bg-yellow-600 rounded-full">
            {disputes.length}
          </div>
        )}
        {show ? (
          <TbChevronUp className="icon" onClick={() => setShow(false)} />
        ) : (
          <TbChevronDown className="icon" onClick={() => setShow(true)} />
        )}
      </Heading>

      {show && (
        <Fragment>
          {disputes.length > 0 ? (
            <div className="list max-h-[400px]">
              {disputes.map((dispute, idx) => (
                <div
                  key={idx}
                  onClick={(e) => navigate(`/disputes?query=${dispute.id}`, e)}
                  className="grid text-sm pill lg:grid-cols-5 text-stone-200"
                >
                  <p className="text-stone-400">
                    {isoDateToString(dispute.dateCreated)}
                  </p>
                  <p className="text-left lg:col-span-2">
                    {toTitleCase(dispute.reason.replaceAll("_", " "))}
                  </p>
                  <p
                    className={`font-semibold text-left ${
                      dispute.status === "won"
                        ? "text-green-600"
                        : dispute.status === "lost"
                        ? "text-red-600"
                        : "text-yellow-600"
                    }`}
                  >
                    {toTitleCase(dispute.status.replaceAll("_", " "))}
                  </p>
                  <p className="ml-auto">{formatCurrency(dispute.amount)}</p>
                </div>
              ))}
            </div>
          ) : (
            <NoRecordsFound />
          )}
        </Fragment>
      )}
    </div>
  );
}
